import { TabPane, Form } from 'reactstrap';
import PropTypes from 'prop-types';
import ModalClickable from '../../../layouts/modals/ModalClickable';
import ModalOptions from '../../../layouts/modals/ModalOptions';
import useDatosPersonales from './hooks/useDatosPersonales';
import SeccionIdentidad from './SeccionIdentidad';
import SeccionResidencia from './SeccionResidencia';
import SeccionNacimiento from './SeccionNacimiento';
import SeccionCentroContacto from './SeccionCentroContacto';
import SeccionOtros from './SeccionOtros';
import FormActions from './FormActions';

const DatosPersonales = ({
  prevActiveTab,
  datosPersonales,
  missingDataFunction,
  menorEdad,
  setMenorEdad,
}) => {
  const {
    formik,
    userOU,
    idCedesca,
    idCntec,
    document,
    country,
    province,
    poblationFiltered,
    poblationBirthFiltered,
    cpFiltered,
    formationCenter,
    fidelitationList,
    isModalShown,
    isModalShown2,
    isModalShown3,
    raw,
    url,
    setIsModalShown2,
    setIsModalShown3,
    tooltipOpen,
    toggleTooltip,
    handleFechaNacimiento,
    handleProvinceChange,
    handlePoblationChange,
    handleBirthProvinceChange,
    handleEmail,
  } = useDatosPersonales({
    datosPersonales,
    missingDataFunction,
    setMenorEdad,
    prevActiveTab,
  });

  return (
    <>
      {isModalShown ? (
        <ModalClickable header="Un usuario ha modificado este alumno recientemente." />
      ) : null}
      {isModalShown2 ? (
        <ModalOptions
          header="¿Desea realizar estos cambios?"
          url={url}
          raw={raw}
          load={setIsModalShown2}
          text1="Cancelar"
          color1="danger"
          text2="Aceptar"
          color2="primary"
        />
      ) : null}
      {isModalShown3 ? (
        <ModalOptions
          header="¿Desea reenviar el email con las credenciales?"
          url={url}
          raw={raw}
          load={setIsModalShown3}
          text1="Cancelar"
          color1="danger"
          text2="Enviar"
          color2="primary"
        />
      ) : null}

      <TabPane tabId="1">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <SeccionIdentidad
            formik={formik}
            document={document}
            menorEdad={menorEdad}
            userOU={userOU}
            handleFechaNacimiento={handleFechaNacimiento}
          />
          <SeccionResidencia
            formik={formik}
            country={country}
            province={province}
            poblationFiltered={poblationFiltered}
            cpFiltered={cpFiltered}
            userOU={userOU}
            handleProvinceChange={handleProvinceChange}
            handlePoblationChange={handlePoblationChange}
          />
          <SeccionNacimiento
            formik={formik}
            country={country}
            province={province}
            poblationBirthFiltered={poblationBirthFiltered}
            userOU={userOU}
            handleBirthProvinceChange={handleBirthProvinceChange}
          />
          <SeccionCentroContacto
            formik={formik}
            formationCenter={formationCenter}
            userOU={userOU}
            idCedesca={idCedesca}
            idCntec={idCntec}
          />
          <SeccionOtros formik={formik} fidelitationList={fidelitationList} userOU={userOU} />
          <FormActions
            formik={formik}
            userOU={userOU}
            tooltipOpen={tooltipOpen}
            toggleTooltip={toggleTooltip}
            handleEmail={handleEmail}
          />
        </Form>
      </TabPane>
    </>
  );
};

DatosPersonales.propTypes = {
  prevActiveTab: PropTypes.string,
  datosPersonales: PropTypes.object,
  missingDataFunction: PropTypes.func,
  menorEdad: PropTypes.bool,
  setMenorEdad: PropTypes.func,
};

export default DatosPersonales;
